import React from 'react';

export default function MenuItemSeparator() {
  return (
    <li className="kt-menu__separator">
      <span />
    </li>
  );
}
